import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TableOfContents = ({ sections }) => {
  const [activeSection, setActiveSection] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0px -35% 0px' }
    );

    sections.forEach(({ id }) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, [sections]);

  return (
    <div 
      className="fixed right-8 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col gap-2 items-end"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {sections.map(({ id, label }) => {
        const isActive = activeSection === id;
        
        return (
          <a 
            key={id} 
            href={`#${id}`}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="group flex items-center gap-3 py-1 relative"
          >
            {/* Label (Tooltip style) */}
            <AnimatePresence>
              {(isHovered || isActive) && (
                <motion.span 
                  initial={{ opacity: 0, x: 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 10 }}
                  className={`text-sm font-medium whitespace-nowrap bg-white/90 backdrop-blur px-2 py-1 rounded shadow-sm border border-neutral-100
                    ${isActive ? 'text-neutral-900' : 'text-neutral-400'}
                  `}
                >
                  {label}
                </motion.span>
              )}
            </AnimatePresence>

            {/* Dash Indicator */}
            <div 
              className={`h-[2px] transition-all duration-300 rounded-full
                ${isActive 
                  ? 'w-8 bg-neutral-900' 
                  : 'w-4 bg-neutral-300 group-hover:bg-neutral-400 group-hover:w-6'
                }
              `} 
            />
          </a>
        );
      })}
    </div>
  );
};

export default TableOfContents;
